import { SvgIcon, SvgIconProps } from '@mui/material'

const SrpTipOfferIcon = (props: SvgIconProps) => (
    <SvgIcon {...props} viewBox="0 0 32 32">
        <svg fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_6440_54293)">
                <path d="M27.9224 17.3574C28.2042 14.8831 27.7093 12.3825 26.5063 10.2021C25.3032 8.02175 23.4517 6.26967 21.2082 5.18876C18.9648 4.10784 16.4407 3.75165 13.9857 4.16955C11.5308 4.58745 9.2667 5.75874 7.50728 7.52106C5.74785 9.28337 4.58028 11.5494 4.16641 14.005C3.75254 16.4606 4.11288 18.9842 5.19748 21.2258C6.28207 23.4675 8.0372 25.3162 10.2195 26.5156C12.4019 27.7151 14.9033 28.2059 17.3771 27.92" stroke="#154588" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M16 9.33334V16L18.6667 18.6667" stroke="#154588" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M22.6665 22.6667V29.3333" stroke="#FEC524" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M28 22.6667V29.3333" stroke="#FEC524" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </g>
            <defs>
                <clipPath id="clip0_6440_54293">
                    <rect width="32" height="32" fill="white"/>
                </clipPath>
            </defs>
        </svg>
    </SvgIcon>
)

export default SrpTipOfferIcon
